"use client";
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Healthcare industry expertise",
    "Proven track record",
    "End-to-End service",
    "Compliance & data security",

  ];

  const tabContent = [
    {
      heading: "Client-Centric Approach",
      subheading: "With in-depth experience in healthcare claims analytics, we understand the challenges and complexities of the sector and offer solutions that are designed to meet its unique requirements.",
      image: cl1Tab,
    },
    {
      heading: "Proven track record",
      subheading: " Our analytics solutions deliver measurable improvements, from cost savings and faster claims processing to enhanced compliance and fraud detection. ",
      image: cl2Tab,
    },
    {
      heading: "End-to-End service",
      subheading: " We support every stage of the analytics journey, from data integration to insight generation and implementation, providing a comprehensive solution for claims analytics.",
      image: cl3Tab,
    },
    {
      heading: "Compliance & data security",
      subheading: "In healthcare, data security and regulatory compliance are paramount. Our analytics solutions are designed with HIPAA compliance and industry standards in mind to protect patient information and meet regulatory requirements.",
      image: cl4Tab,
    },

  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}

          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${index === activeTab ? "active" : ""
            }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>

          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
              <Image
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].heading}
                width={457}
                height={257}
                className="productbanner_imageslider"
                loading="eager"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
